/* React */
import React from 'react';

/*  NPM  */
import { FormProvider, useForm } from 'react-hook-form';

export const Form = ({
    children,
    'data-testid': dataTestId = 'form',
    defaultValues,
    onSubmit,
    useFormProps = {},
    validator,
    style
}) => {
    const methods = useForm({
        defaultValues,
        mode: 'onSubmit', // validate initially on submit
        resolver: validator,
        reValidateMode: 'onChange', // after submit, revalidate on change
        ...useFormProps
    });

    return (
        <FormProvider {...methods}>
            <form
                data-testid={dataTestId}
                onSubmit={methods.handleSubmit(onSubmit)}
                style={style}
            >
                {children}
            </form>
        </FormProvider>
    );
};
